var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "ci-portfolio-comparison-tile bg-white d-flex p-4",
      on: { click: _vm.redirectToPorfolio },
    },
    [
      !_vm.mobileMode && !_vm.isOwner
        ? _c("ci-bookmark", {
            staticClass: "mr-4 pt-4",
            attrs: { item: _vm.portfolio, type: "portfolios" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.portfolio.model_portfolio
        ? _c("span", {
            staticClass:
              "ci-portfolio-comparison-tile__header_highlight px-3 py-1 font-weight-semi text-sm",
            domProps: {
              textContent: _vm._s(
                _vm.$t("ui.components.portfolios.tile.model_portfolio.header")
              ),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.mobileMode && _vm.isOwner
        ? _c("div", { staticClass: "mx-5" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-wrapper w-100 pt-4" },
        [
          _c("div", { staticClass: "portfolio-info mr-3" }, [
            _vm.isOwner
              ? _c("p", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("ui.shared.portfolios.my_portfolio")
                    ),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isOwner
              ? _c(
                  "div",
                  { staticClass: "user-info row m-0 align-items-center" },
                  [
                    _c("ci-user-avatar", {
                      attrs: {
                        size: "sm",
                        src: _vm.portfolio.owner.avatar,
                        "show-verified-badge": _vm.portfolio.owner.professional,
                        username: _vm.portfolio.owner.name,
                      },
                    }),
                    _vm._v(" "),
                    _c("a", {
                      staticClass:
                        "font-weight-bold text-body d-flex align-items-center ml-2",
                      attrs: {
                        href: _vm.portfolio.owner.url,
                        target: "_blank",
                        rel: "noopener",
                      },
                      domProps: {
                        textContent: _vm._s(_vm.portfolio.owner.name),
                      },
                      on: { click: _vm.handleOwnerClicked },
                    }),
                    _vm._v(" "),
                    _vm.mobileMode
                      ? _c("ci-bookmark", {
                          staticClass: "ml-auto",
                          attrs: { item: _vm.portfolio, type: "portfolios" },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("h5", {
              staticClass: "my-3 h5",
              domProps: { textContent: _vm._s(_vm.portfolio.name) },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-wrap text-muted text-xs" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip",
                      value: _vm.$t("ui.shared.global.creation_date"),
                      expression: "$t('ui.shared.global.creation_date')",
                    },
                  ],
                  staticClass: "d-flex align-items-center mr-3",
                },
                [
                  _c("div", {
                    staticClass: "mdi mdi-calendar-today mdi-18px mr-1",
                  }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "ci-format-date",
                        rawName: "v-ci-format-date",
                        value: _vm.portfolio.created_at,
                        expression: "portfolio.created_at",
                      },
                    ],
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip",
                      value: _vm.$t("ui.shared.global.update_date"),
                      expression: "$t('ui.shared.global.update_date')",
                    },
                  ],
                  staticClass: "d-flex align-items-center mr-3",
                },
                [
                  _c("div", { staticClass: "mdi mdi-history mdi-18px mr-1" }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "ci-format-date",
                        rawName: "v-ci-format-date",
                        value: _vm.portfolio.updated_at,
                        expression: "portfolio.updated_at",
                      },
                    ],
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex align-items-center mr-3" }, [
                _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("ui.shared.portfolios.products_count", {
                        count: _vm.portfolio.portfolio_products.length,
                      })
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex align-items-center mr-3" }, [
                _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("ui.shared.portfolios.followers_count", {
                        count: _vm.portfolio.followers_count,
                      })
                    ),
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "stats d-flex flex-wrap justify-content-start justify-content-xl-center align-items-center",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "metrics d-flex justify-content-start align-items-center flex-wrap",
                },
                _vm._l(_vm.kpis, function (kpi, index) {
                  return _c("div", { key: index, staticClass: "metric" }, [
                    _c("div", {
                      staticClass:
                        "text-xs font-weight-semi text-dark text-uppercase",
                      class: kpi.name,
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t(kpi.label, {
                            period: _vm.performanceInterval.period,
                          })
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "ci-format-percent",
                          rawName: "v-ci-format-percent.style",
                          value: kpi.value,
                          expression: "kpi.value",
                          modifiers: { style: true },
                        },
                      ],
                      staticClass: "font-weight-bold",
                    }),
                  ])
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _vm.chartData
            ? _c("ci-highcharts", {
                staticClass: "chart",
                attrs: {
                  disabled: _vm.dataDisabled,
                  "disabled-text": _vm.disableChartText,
                  options: _vm.chartData,
                  "constructor-type": "stockChart",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }